export class EmailInputDto {
  orderId = 0;
  emailType = "";
  emailAddress = "";
  orderDetailIds: number[] = [];
  invoiceIds: number[] = [];
}
